<template>
    <div class="row bt-dash">
        <div class="col-12 p-0">
            <table class="w-100 table" style="border-collapse: collapse;">
                <thead>
                    <tr>
                        <th class="text-center">Level</th>
                        <th>Price</th>
                        <th>HALO</th>
                        <th>LALO</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="priceLevel in priceLevels" :key="priceLevel.id">
                        <td>
                            <div
                                class="d-flex justify-content-center align-items-center gap-2 form-check checkbox-checked">
                                <input type="checkbox" :id="`checkbox-${priceLevel.id}`" v-model="priceLevel.Level"
                                    class="form-check-input" />
                                <label :for="`checkbox-${priceLevel.id}`" style="margin-top: 12px;">{{ priceLevel.id
                                    }}.</label>
                            </div>
                        </td>
                        <td>
                            <input class="w-100" type="number" v-model="priceLevel.price" />
                        </td>
                        <td>
                            <input class="w-100" type="number" v-model="priceLevel.halo" />
                        </td>
                        <td>
                            <input class="w-100" type="number" v-model="priceLevel.lalo" />
                        </td>
                    </tr>
                    <tr class="hover-shadow">
                        <td colspan="4" class="text-center hover-pointer" @click="addPriceLevel">
                            <h5>Add Price Level +</h5>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';

const priceLevels = ref(
    Array.from({ length: 3 }, (_, i) => ({
        id: `${i + 1}`,
        Level: false,
        price: 0,
        halo: 0,
        lalo: 0,
    }))
);

const addPriceLevel = () => {
    const newId = priceLevels.value.length + 1;
    priceLevels.value.push({
        id: `${newId}`,
        Level: false,
        price: 0,
        halo: 0,
        lalo: 0,
    });
};
</script>

<style scoped lang="scss">
.hover-shadow {
    transition: background-color 0.3s ease;
}

.hover-shadow:hover {
    background-color: rgba(0, 0, 0, 0.05);
}
</style>